import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

import SubtitleSeparator from "./SubtitleSeparator";

TurnoverSubtitle.propTypes = {
    averageCart: PropTypes.number,
    onlineTurnoverTotal: PropTypes.number,
    currency: PropTypes.string,
};

function TurnoverSubtitle({averageCart, onlineTurnoverTotal, currency, ...props}) {
    if (!onlineTurnoverTotal) {
        return null;
    }
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
        }}>
            <FormattedMessage id={'dashboard.saleValuesAndVolume.turnover.subtitle.turnover'} />
            <SubtitleSeparator />
            <FormattedMessage
                id={'dashboard.saleValuesAndVolume.turnover.subtitle.averageCart'}
                values={{
                    averageCart: props.intl.formatNumber(
                       averageCart,
                        {style: "currency", currency: currency ?? "EUR", maximumFractionDigits: 2 }
                    )
                }}
            />
        </div>
    );
}

export default injectIntl(TurnoverSubtitle);
